import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { useSearchParams } from "react-router-dom";
import { cmmsTheme } from "@setup/theme/cmms-theme";

// MuiGrid-item
export const DownHoursFilter = () => {
	//routes
	const [searchParams, setSearchParams] = useSearchParams();
	const downHours = searchParams.get("downHours") ?? "";

	const handleFilter = (e: any) => {
		searchParams.set("downHours", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<Box position="relative">
			<TextField
				type="number"
				label="Down hours"
				variant="outlined"
				margin="dense"
				value={downHours}
				onChange={handleFilter}
				fullWidth
				autoComplete="off"
				InputLabelProps={{
					style: {
						transform: "translate(14px, -6px) scale(0.75)",
						backgroundColor: cmmsTheme.colors.surfaceWhite,
						transition: "none !important",
						left: -3.5,
						padding: "0 5px"
					}
				}}
				InputProps={{
					style: {
						color: "black",
						paddingRight: 45,
						borderTopLeftRadius: 3,
						borderTopRightRadius: 3
					}
				}} />
			<>
				<i
					className="fa fa-keyboard"
					style={{
						position: "absolute",
						right: 17,
						top: 20,
						cursor: "pointer",
					}}></i>
			</>
		</Box>
	);
};
